import { observer } from 'mobx-react';
import React from 'react';
import { Card, CardContent, Heading, Notice, Separator, Text } from 'telia-front-react';
import { TranslationsContext } from '@teliaee/telia-translate';
import { GridProps, PackageOptionGroup } from '../MobileBusinessInterfaces';
import PackageOptionCardGroup from './PackageOptionCardGroup';

interface Props {
  packageOptionGroups: PackageOptionGroup[];
  gridProps: GridProps;
}

const conditionalSeparator = (condition: boolean) => condition && <Separator weight="thin" spacing="xsmall" />;

@observer
class PackageOptionCardGroups extends React.Component<Props> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;
  private mapPackageOptionGroupsToCardGroups() {
    const translate = this.context.translate;
    const { packageOptionGroups } = this.props;
    return packageOptionGroups.map((group, groupIndex) => {
      const length = packageOptionGroups.length;
      return (
        <React.Fragment key={group.name}>
          {group.noticeHtmlKey && (
            <>
              <Notice size="small">{translate(group.noticeHtmlKey)}</Notice>
              <Separator color="invisible" spacing="xsmall" />
            </>
          )}
          <PackageOptionCardGroup group={group} gridProps={this.props.gridProps} />
          {conditionalSeparator(length > 1 && groupIndex !== length - 1)}
        </React.Fragment>
      );
    });
  }

  public render() {
    const translate = this.context.translate;
    return (
      <Card>
        <CardContent>
          <Text>
            <Heading element="h3" className="h4 text-bold">
              {translate('mobileBusiness.form.packageOptionsHeader')}
            </Heading>
            {this.mapPackageOptionGroupsToCardGroups()}
          </Text>
        </CardContent>
      </Card>
    );
  }
}

export default PackageOptionCardGroups;
